<template>
  <div>
    <div class="pagar" style="margin-bottom: 35px;">
      <Titulo Titulo="Pagar con" />
    </div>
    <v-col>
      <v-row class="alineacion" style="display:flex; align-items:center; justify-content:center; flex-wrap:nowrap;">
        <div class="paypal" style="margin-top: 5px;">
          <Paypal :boletos_ida="boletos_ida" :boletos_vuelta="boletos_vuelta" />
        </div>
        <div class="credito">
          <div class="tarjeta" style="margin-top: -25px;">
            <img src="img/cards1.png" />
          </div>
          <router-link to="/pagar">
            <div class="openpay border" :class="['bg-btn-'+mainClass, '!border-btn-'+mainClass]">
              <p style="margin-top: 2px;">Tarjeta</p>
          </div>
          </router-link>
        </div>

        <div class="servicio">
          <router-link v-if="validacion()" to="/recibo">
            <div class="tarjeta" style="margin-top: -38px;">
              <img src="img/tiendas.png" style="margin-bottom: 2px;"/>
            </div>
            <div class="openpay border" :class="['bg-btn-'+mainClass, '!border-btn-'+mainClass]">
              <p style="margin-top: 2px;">Tienda</p>
            </div>
          </router-link>
        </div>
      </v-row>
    </v-col>
  </div>
</template>

<style scoped lang="less">
.v-menu__content {
  background-color: white;
  margin-top: -60px;
  height: 170px;
  width: 250px;
  border-radius: 20px;
  z-index: 10000;
}
@import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800&display=swap");
@media screen and (max-width: 480px) {
  .alineacion {
    margin-left:-30px !important;
    margin-top: -50px !important;
    flex-wrap: wrap !important;
    flex-direction: column !important;
    align-items: center !important;
  }
  .credito {
    margin-left: -0px !important;
    margin-top: 25px !important;
  }
  .servicio {
    margin-left: -40px !important;
    margin-top: 50px;
  }
  .pagar {
    font-family: "Montserrat";
    font-size: 20px;
    font-weight: bold;
    margin-left: -10%;
    margin-top: 0%;
  }
  .paypal {
    margin-left: 0;
    
  }
  .imagen {
    margin-top: -27%;
    margin-left: 9%;
  }
  .openpay {
    font-family: "Montserrat";
    font-weight: 600;
    font-size: 16px;
    color: rgb(255, 255, 255);
    border-radius: 30px;
    height: 40px;
    width: 140px;
    margin-left: 5%;
    margin-top: -0%;
  }
  .imagenopen {
    margin-top: -3%;
    margin-left: 3%;
  }

  #overlay {
    display: none;
    position: absolute;
    top: 0;
    bottom: 0;
    background: #999;
    width: 0%;
    height: 0%;
    opacity: 0.8;
    z-index: 100;
  }
  #popup {
    display: none;
    position: absolute;
    background: #fff;
    width: 270px;
    height: 150px;
    margin-left: 90px; /*Half the value of width to center div*/
    margin-top: -180px; /*Half the value of height to center div*/
    z-index: 200;
    border-radius: 20px;
    box-shadow: 0px 10px 10px rgba(0, 0, 0, 0.2);
  }
  #popupclose {
    float: right;
    padding: 10px;
    cursor: pointer;
  }
  .popupcontent {
    padding: 10px;
  }
  .credito {
    font-family: "Montserrat";
    font-weight: 400;
    font-size: 18px;
    color: black;
    margin-right: 0%;
    margin-left: 15px;
  }
  .servicio {
    font-family: "Montserrat";
    font-weight: 400;
    font-size: 18px;
    color: black;
    margin-right: -10%;
    margin-left: 15px;
  }

  .cerrar {
    margin-top: -600%;
    margin-left: 10%;
  }
  .tarjeta {
    width: 150px;
  }
  .tarjeta2 {
    width: 100px;
  }
  .tienda {
    font-family: "Montserrat";
    box-shadow: -2px 3px 3px 1px rgba(208, 215, 230, 255);
    font-size: 18px;
    background-color: #822c30;
    color: rgb(255, 255, 255);
    border: 1px solid #822c30;
    border-radius: 10px;
    height: 35px;
    width: 190px;
    font-weight: 500;
    margin-left: -20px;
    margin-top: 5%;
  }
  .pagotarjeta {
    font-family: "Montserrat";
    box-shadow: -2px 3px 3px 1px rgba(208, 215, 230, 255);
    font-size: 18px;
    background-color: #822c30;
    color: rgb(255, 255, 255);
    border: 1px solid #822c30;
    border-radius: 10px;
    height: 35px;
    width: 190px;
    font-weight: 500;
    margin-left: -20px;
    margin-top: 5%;
  }
}
@media screen and (min-width: 481px) and (max-width: 679px) {
  .alineacion {
    margin-left: -30px !important;
    flex-wrap: wrap !important;
    flex-direction: column !important;
    align-items: center !important;
  }
  .credito {
    margin-left: 0px !important;
    margin-top: 25px !important;
  }
  .servicio {
    margin-left: -50px !important;
    margin-top: 50px !important;
  }
  .pagar {
    font-family: "Montserrat";
    font-size: 20px;
    font-weight: bold;
    margin-left: -10%;
    margin-top: 0%;
  }
  .paypal {
    margin-left: 0;
    
  }
  .imagen {
    margin-top: -27%;
    margin-left: 9%;
  }
  .openpay {
    font-family: "Montserrat";
    font-weight: 600;
    font-size: 16px;
    color: rgb(255, 255, 255);
    border-radius: 30px;
    height: 40px;
    width: 140px;
    margin-left: 5%;
    margin-top: -0%;
  }
  .imagenopen {
    margin-top: -3%;
    margin-left: 3%;
  }

  #overlay {
    display: none;
    position: absolute;
    top: 0;
    bottom: 0;
    background: #999;
    width: 0%;
    height: 0%;
    opacity: 0.8;
    z-index: 100;
  }
  #popup {
    display: none;
    position: absolute;
    top: 120%;
    left: 50%;
    background: #fff;
    width: 270px;
    height: 150px;
    margin-left: -80px; /*Half the value of width to center div*/
    margin-top: 800px; /*Half the value of height to center div*/
    z-index: 200;
    border-radius: 20px;
    box-shadow: 0px 10px 10px rgba(0, 0, 0, 0.2);
  }
  #popupclose {
    float: right;
    padding: -130px;
    cursor: pointer;
  }
  .popupcontent {
    padding: 10px;
  }
  .credito {
    font-family: "Montserrat";
    font-weight: 400;
    font-size: 18px;
    color: black;
    margin-right: 0%;
    margin-left: 15px;
  }
  .servicio {
    font-family: "Montserrat";
    font-weight: 400;
    font-size: 18px;
    color: black;
    margin-right: -10%;
    margin-left: 15px;
  }

  .cerrar {
    margin-top: 40%;
    margin-left: -25%;
  }
  .tarjeta {
    width: 150px;
  }
  .tarjeta2 {
    width: 100px;
  }
  .tienda {
    font-family: "Montserrat";
    box-shadow: -2px 3px 3px 1px rgba(208, 215, 230, 255);
    font-size: 18px;
    background-color: #822c30;
    color: rgb(255, 255, 255);
    border: 1px solid #822c30;
    border-radius: 10px;
    height: 35px;
    width: 190px;
    font-weight: 500;
    margin-left: -20px;
    margin-top: 5%;
  }
  .pagotarjeta {
    font-family: "Montserrat";
    box-shadow: -2px 3px 3px 1px rgba(208, 215, 230, 255);
    font-size: 18px;
    background-color: #822c30;
    color: rgb(255, 255, 255);
    border: 1px solid #822c30;
    border-radius: 10px;
    height: 35px;
    width: 190px;
    font-weight: 500;
    margin-left: -20px;
    margin-top: 5%;
  }
}
@media screen and (min-width: 680px) and (max-width: 800px) {
  .alineacion {
    margin-left: -105px;
  }
  .pagar {
    font-family: "Montserrat";
    font-size: 22px;
    font-weight: bold;
    margin-left: -1%;
    margin-top: 0%;
  }
  .paypal {
    margin-left: 0;
    
  }
  .imagen {
    margin-top: -27%;
    margin-left: 9%;
  }
  .openpay {
    font-family: "Montserrat";
    font-weight: 600;
    font-size: 16px;
    color: rgb(255, 255, 255);
    border-radius: 30px;
    height: 40px;
    width: 140px;
    margin-left: 5%;
    margin-top: -0%;
  }
 .imagenopen {
    margin-top: -3%;
    margin-left: 3%;
  }

  #overlay {
    display: none;
    position: absolute;
    top: 0;
    bottom: 0;
    background: #999;
    width: 0%;
    height: 0%;
    opacity: 0.8;
    z-index: 100;
  }
  #popup {
    display: none;
    position: absolute;
    top: 94%;
    left: 50%;
    background: #fff;
    width: 270px;
    height: 150px;
    margin-left: -30px; /*Half the value of width to center div*/
    margin-top: -100px; /*Half the value of height to center div*/
    z-index: 200;
    border-radius: 20px;
    box-shadow: 0px 10px 10px rgba(0, 0, 0, 0.2);
  }
  #popupclose {
    float: right;
    padding: 10px;
    cursor: pointer;
  }
  .popupcontent {
    padding: 10px;
  }
  .credito {
    font-family: "Montserrat";
    font-weight: 400;
    font-size: 18px;
    color: black;
    margin-right: 0%;
    margin-left: 15px;
  }
  .servicio {
    font-family: "Montserrat";
    font-weight: 400;
    font-size: 18px;
    color: black;
    margin-right: -10%;
    margin-left: 15px;
  }

  .cerrar {
    margin-top: 40%;
    margin-left: -25%;
  }
  .tarjeta {
    width: 150px;
  }
  .tarjeta2 {
    width: 100px;
  }
  .tienda {
    font-family: "Montserrat";
    box-shadow: -2px 3px 3px 1px rgba(208, 215, 230, 255);
    font-size: 18px;
    background-color: #822c30;
    color: rgb(255, 255, 255);
    border: 1px solid #822c30;
    border-radius: 10px;
    height: 35px;
    width: 190px;
    font-weight: 500;
    margin-left: -20px;
    margin-top: 5%;
  }
  .pagotarjeta {
    font-family: "Montserrat";
    box-shadow: -2px 3px 3px 1px rgba(208, 215, 230, 255);
    font-size: 18px;
    background-color: #822c30;
    color: rgb(255, 255, 255);
    border: 1px solid #822c30;
    border-radius: 10px;
    height: 35px;
    width: 190px;
    font-weight: 500;
    margin-left: -20px;
    margin-top: 5%;
  }
}
@media screen and (min-width: 801px) and (max-width: 1200px) {
  .alineacion {
    margin-left: -240px;
  }
  .pagar {
    font-family: "Montserrat";
    font-size: 20px;
    font-weight: bold;
    margin-left: -10%;
    margin-top: 0%;
  }
  .paypal {
    margin-left: 0;
  }
  .imagen {
    margin-top: -27%;
    margin-left: 9%;
  }
  .openpay {
    font-family: "Montserrat";
    font-weight: 600;
    font-size: 16px;
    color: rgb(255, 255, 255);
    border-radius: 30px;
    height: 40px;
    width: 140px;
    margin-left: 5%;
    margin-top: -0%;
  }
  .imagenopen {
    margin-top: -3%;
    margin-left: 3%;
  }
  #overlay {
    display: none;
    position: absolute;
    top: 0;
    bottom: 0;
    background: #999;
    width: 0%;
    height: 0%;
    opacity: 0.8;
    z-index: 100;
  }
  #popup {
    display: none;
    position: absolute;
    top: 235%;
    left: 50%;
    background: #fff;
    width: 270px;
    height: 150px;
    margin-left: -30px; /*Half the value of width to center div*/
    margin-top: -100px; /*Half the value of height to center div*/
    z-index: 200;
    border-radius: 20px;
    box-shadow: 0px 10px 10px rgba(0, 0, 0, 0.2);
  }
  #popupclose {
    float: right;
    padding: 10px;
    cursor: pointer;
  }
  .popupcontent {
    padding: 10px;
  }
  .credito {
    font-family: "Montserrat";
    font-weight: 400;
    font-size: 18px;
    color: black;
    margin-right: 0%;
    margin-left: 15px;
  }
  .servicio {
    font-family: "Montserrat";
    font-weight: 400;
    font-size: 18px;
    color: black;
    margin-right: -10%;
    margin-left: 15px;
  }
  .cerrar {
    margin-top: 40%;
    margin-left: -25%;
  }
  .tarjeta {
    width: 150px;
  }
  .tarjeta2 {
    width: 100px;
  }
  .tienda {
    font-family: "Montserrat";
    box-shadow: -2px 3px 3px 1px rgba(208, 215, 230, 255);
    font-size: 18px;
    background-color: #822c30;
    color: rgb(255, 255, 255);
    border: 1px solid #822c30;
    border-radius: 10px;
    height: 35px;
    width: 190px;
    font-weight: 500;
    margin-left: -20px;
    margin-top: 5%;
  }
  .pagotarjeta {
    font-family: "Montserrat";
    box-shadow: -2px 3px 3px 1px rgba(208, 215, 230, 255);
    font-size: 18px;
    background-color: #822c30;
    color: rgb(255, 255, 255);
    border: 1px solid #822c30;
    border-radius: 10px;
    height: 35px;
    width: 190px;
    font-weight: 500;
    margin-left: -20px;
    margin-top: 5%;
  }
}
@media screen and (min-width: 1201px) and (max-width: 1365px) {
  .alineacion {
    margin-left: -210px;
  }
  .pagar {
    font-family: "Montserrat";
    font-size: 20px;
    font-weight: bold;
    margin-left: -5%;
    margin-top: 0%;
  }
  .paypal {
    margin-left: 0;
  }
  .imagen {
    margin-top: -27%;
    margin-left: 9%;
  }
  .openpay {
    font-family: "Montserrat";
    font-weight: 600;
    font-size: 16px;
    color: rgb(255, 255, 255);
    border-radius: 30px;
    height: 40px;
    width: 140px;
    margin-left: 5%;
    margin-top: -0%;
  }
  .imagenopen {
    margin-top: -3%;
    margin-left: 3%;
  }
  #overlay {
    display: none;
    position: absolute;
    top: 0;
    bottom: 0;
    background: #999;
    width: 0%;
    height: 0%;
    opacity: 0.8;
    z-index: 100;
  }
  #popup {
    display: none;
    position: absolute;
    background: #fff;
    width: 270px;
    height: 150px;
    margin-left: 550px; /*Half the value of width to center div*/
    margin-top: -175px; /*Half the value of height to center div*/
    z-index: 200;
    border-radius: 20px;
    box-shadow: 0px 10px 10px rgba(0, 0, 0, 0.2);
  }
  #popupclose {
    float: right;
    padding: 10px;
    cursor: pointer;
  }
  .popupcontent {
    padding: 10px;
  }
  .credito {
    font-family: "Montserrat";
    font-weight: 400;
    font-size: 18px;
    color: black;
    margin-right: 0%;
    margin-left: 15px;
  }
  .servicio {
    font-family: "Montserrat";
    font-weight: 400;
    font-size: 18px;
    color: black;
    margin-right: -10%;
    margin-left: 15px;
  }
  .cerrar {
    margin-top: -600%;
    margin-left: 15%;
  }
  .tarjeta {
    width: 150px;
  }
  .tarjeta2 {
    width: 100px;
  }
  .tienda {
    font-family: "Montserrat";
    box-shadow: -2px 3px 3px 1px rgba(208, 215, 230, 255);
    font-size: 18px;
    background-color: #822c30;
    color: rgb(255, 255, 255);
    border: 1px solid #822c30;
    border-radius: 10px;
    height: 35px;
    width: 190px;
    font-weight: 500;
    margin-left: -20px;
    margin-top: 5%;
  }
  .pagotarjeta {
    font-family: "Montserrat";
    box-shadow: -2px 3px 3px 1px rgba(208, 215, 230, 255);
    font-size: 18px;
    background-color: #822c30;
    color: rgb(255, 255, 255);
    border: 1px solid #822c30;
    border-radius: 10px;
    height: 35px;
    width: 190px;
    font-weight: 500;
    margin-left: -20px;
    margin-top: 5%;
  }
}
@media screen and (min-width: 1366px) and (max-width: 1439px) {
  .alineacion {
    margin-left: -230px;
  }
  .pagar {
    font-family: "Montserrat";
    font-size: 20px;
    font-weight: bold;
    margin-left: -5%;
    margin-top: 0%;
  }
  .paypal {
    margin-left: 0;
  }
  .imagen {
    margin-top: -27%;
    margin-left: 9%;
  }
  .openpay {
    font-family: "Montserrat";
    font-weight: 600;
    font-size: 16px;
    color: rgb(255, 255, 255);
    border-radius: 30px;
    height: 40px;
    width: 140px;
    margin-left: 5%;
    margin-top: -0%;
  }
  .imagenopen {
    margin-top: -3%;
    margin-left: 3%;
  }
  #overlay {
    display: none;
    position: absolute;
    top: 0;
    bottom: 0;
    background: #999;
    width: 0%;
    height: 0%;
    opacity: 0.8;
    z-index: 100;
  }
  #popup {
    display: none;
    position: absolute;
    background: #fff;
    width: 270px;
    height: 150px;
    margin-left: 630px; /*Half the value of width to center div*/
    margin-top: -175px; /*Half the value of height to center div*/
    z-index: 200;
    border-radius: 20px;
    box-shadow: 0px 10px 10px rgba(0, 0, 0, 0.2);
  }
  #popupclose {
    float: right;
    padding: 10px;
    cursor: pointer;
  }
  .popupcontent {
    padding: 10px;
  }
  .credito {
    font-family: "Montserrat";
    font-weight: 400;
    font-size: 18px;
    color: black;
    margin-right: 0%;
    margin-left: 15px;
  }
  .servicio {
    font-family: "Montserrat";
    font-weight: 400;
    font-size: 18px;
    color: black;
    margin-right: -10%;
    margin-left: 15px;
  }
  .cerrar {
    margin-top: -600%;
    margin-left: 15%;
  }
  .tarjeta {
    width: 150px;
  }
  .tarjeta2 {
    width: 100px;
  }
  .tienda {
    font-family: "Montserrat";
    box-shadow: -2px 3px 3px 1px rgba(208, 215, 230, 255);
    font-size: 18px;
    background-color: #822c30;
    color: rgb(255, 255, 255);
    border: 1px solid #822c30;
    border-radius: 10px;
    height: 35px;
    width: 190px;
    font-weight: 500;
    margin-left: -20px;
    margin-top: 5%;
  }
  .pagotarjeta {
    font-family: "Montserrat";
    box-shadow: -2px 3px 3px 1px rgba(208, 215, 230, 255);
    font-size: 18px;
    background-color: #822c30;
    color: rgb(255, 255, 255);
    border: 1px solid #822c30;
    border-radius: 10px;
    height: 35px;
    width: 190px;
    font-weight: 500;
    margin-left: -20px;
    margin-top: 5%;
  }
}
@media screen and (min-width: 1440px) and (max-width: 1919px) {
  .alineacion {
    margin-left: -240px;
  }
  .pagar {
    font-family: "Montserrat";
    font-size: 20px;
    font-weight: bold;
    margin-left: -5%;
    margin-top: 0%;
  }
  .paypal {
    margin-left: 0;
  }
  .imagen {
    margin-top: -27%;
    margin-left: 9%;
  }
  .openpay {
    font-family: "Montserrat";
    font-weight: 600;
    font-size: 16px;
    color: rgb(255, 255, 255);
    border-radius: 30px;
    height: 40px;
    width: 140px;
    margin-left: 5%;
    margin-top: -0%;
  }
  .imagenopen {
    margin-top: -3%;
    margin-left: 3%;
  }
  #overlay {
    display: none;
    position: absolute;
    top: 0;
    bottom: 0;
    background: #999;
    width: 0%;
    height: 0%;
    opacity: 0.8;
    z-index: 100;
  }
  #popup {
    display: none;
    position: absolute;
    background: #fff;
    width: 270px;
    height: 150px;
    margin-left: 665px; /*Half the value of width to center div*/
    margin-top: -175px; /*Half the value of height to center div*/
    z-index: 200;
    border-radius: 20px;
    box-shadow: 0px 10px 10px rgba(0, 0, 0, 0.2);
  }
  #popupclose {
    float: right;
    padding: 10px;
    cursor: pointer;
  }
  .popupcontent {
    padding: 10px;
  }
  .credito {
    font-family: "Montserrat";
    font-weight: 400;
    font-size: 18px;
    color: black;
    margin-right: 0%;
    margin-left: 15px;
  }
  .servicio {
    font-family: "Montserrat";
    font-weight: 400;
    font-size: 18px;
    color: black;
    margin-right: -10%;
    margin-left: 15px;
  }
  .cerrar {
    margin-top: -600%;
    margin-left: 15%;
  }
  .tarjeta {
    width: 150px;
  }
  .tarjeta2 {
    width: 100px;
  }
  .tienda {
    font-family: "Montserrat";
    box-shadow: -2px 3px 3px 1px rgba(208, 215, 230, 255);
    font-size: 18px;
    background-color: #822c30;
    color: rgb(255, 255, 255);
    border: 1px solid #822c30;
    border-radius: 10px;
    height: 35px;
    width: 190px;
    font-weight: 500;
    margin-left: -20px;
    margin-top: 5%;
  }
  .pagotarjeta {
    font-family: "Montserrat";
    box-shadow: -2px 3px 3px 1px rgba(208, 215, 230, 255);
    font-size: 18px;
    background-color: #822c30;
    color: rgb(255, 255, 255);
    border: 1px solid #822c30;
    border-radius: 10px;
    height: 35px;
    width: 190px;
    font-weight: 500;
    margin-left: -20px;
    margin-top: 5%;
  }
}
@media screen and (min-width: 1920px)  {
  .alineacion {
    margin-left: -200px;
  }
  .pagar {
    font-family: "Montserrat";
    font-size: 20px;
    font-weight: bold;
    margin-left: 0%;
    margin-top: 0%;
  }
  .paypal {
    margin-left: 0;
    
  }
  .imagen {
    margin-top: -27%;
    margin-left: 9%;
  }
  .openpay {
    font-family: "Montserrat";
    font-weight: 600;
    font-size: 16px;
    background-color: #822c30;
    color: rgb(255, 255, 255);
    border: 1px solid #822c30;
    border-radius: 30px;
    height: 40px;
    width: 140px;
    margin-left: 5%;
    margin-top: -0%;
  }
  .imagenopen {
    margin-top: -5%;
    margin-left: 11%;
    margin-right: 5%;
  }

  #overlay {
    display: none;
    position: absolute;
    top: 0;
    bottom: 0;
    background: #999;
    width: 0%;
    height: 0%;
    opacity: 0.8;
    z-index: 100;
  }
  #popup {
    display: none;
    position: absolute;
    background: #fff;
    width: 270px;
    height: 150px;
    margin-left: 1080px; /*Half the value of width to center div*/
    margin-top: -175px; /*Half the value of height to center div*/
    z-index: 200;
    border-radius: 20px;
    box-shadow: 0px 10px 10px rgba(0, 0, 0, 0.2);
  }
  #popupclose {
    float: right;
    padding: 10px;
    cursor: pointer;
  }
  .popupcontent {
    padding: 10px;
  }
  .credito {
    font-family: "Montserrat";
    font-weight: 400;
    font-size: 18px;
    color: black;
    margin-right: 0%;
    margin-left: 15px;
  }
  .servicio {
    font-family: "Montserrat";
    font-weight: 400;
    font-size: 18px;
    color: black;
    margin-right: -10%;
    margin-left: 15px;
  }

  .cerrar {
    margin-top: -600%;
    margin-left: 10%;
  }
  .tarjeta {
    width: 150px;
  }
  .tarjeta2 {
    width: 100px;
  }
  .tienda {
    font-family: "Montserrat";
    box-shadow: -2px 3px 3px 1px rgba(208, 215, 230, 255);
    font-size: 18px;
    background-color: #822c30;
    color: rgb(255, 255, 255);
    border: 1px solid #822c30;
    border-radius: 10px;
    height: 35px;
    width: 190px;
    font-weight: 500;
    margin-left: -20px;
    margin-top: 5%;
  }
  .pagotarjeta {
    font-family: "Montserrat";
    box-shadow: -2px 3px 3px 1px rgba(208, 215, 230, 255);
    font-size: 18px;
    background-color: #822c30;
    color: rgb(255, 255, 255);
    border: 1px solid #822c30;
    border-radius: 10px;
    height: 35px;
    width: 190px;
    font-weight: 500;
    margin-left: -20px;
    margin-top: 5%;
  }
}
</style>


<script>
import Titulo from "@/components/title.vue";
import Paypal from "@/components/Paypal.vue";

export default {
  name: "HomeView",
  computed: {
    mainClass() {
      return process.env.VUE_APP_COLOR;
    }
  },
  components: {
    Titulo,
    Paypal,
  },
  props:{
    boletos_ida: { required: false },
    boletos_vuelta: { required: false }
  },
  data() {
    return {
      menu: false
    };
  },
  methods: {
    iniciar() {
      // Initialize Variables
      var closePopup = document.getElementById("popupclose");
      var overlay = document.getElementById("overlay");
      var popup = document.getElementById("popup");
      var button = document.getElementById("button");
      // Close Popup Event
      closePopup.onclick = function () {
        overlay.style.display = "none";
        popup.style.display = "none";
      };
      // Show Overlay and Popup
      button.onclick = function () {
        overlay.style.display = "block";
        popup.style.display = "block";
      };
    },
    validacion() {
      const horas_eliminar = parseInt(localStorage.getItem("horas_eliminar_reserva_antes_salida")); 
      const fecha_salida_str = localStorage.getItem("fecha_ida_hora");

      const fecha_salida = new Date(fecha_salida_str.replace(" ", "T")); 
      const fecha_actual = new Date();

      const fecha_limite = new Date(fecha_salida.getTime() - horas_eliminar * 60 * 60 * 1000);

      return fecha_actual < fecha_limite;
    }
  },
};
</script>
